import * as React from 'react';
export const tempoSvg = React.forwardRef(function tempoSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#000',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M14.655 25h-4.494l4.165-13.147H9L10.161 8H25l-1.161 3.853h-5.041L14.655 25Z',
      fill: '#fff',
    }),
  );
});
tempoSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var tempo = {
  category: 'brand',
  colorable: false,
  name: 'tempo',
  svg: tempoSvg,
};
